export function parseOfferIds(rawIds: string): Array<string> {
  return Array.from(
    new Set(
      rawIds
        .split(/[\s,]+/)
        .map((value) => value.trim())
        .filter(Boolean),
    ),
  );
}
